import { render, staticRenderFns } from "./upauctionrecord.vue?vue&type=template&id=5ec1e97c&scoped=true&"
import script from "./upauctionrecord.vue?vue&type=script&lang=js&"
export * from "./upauctionrecord.vue?vue&type=script&lang=js&"
import style0 from "./upauctionrecord.vue?vue&type=style&index=0&id=5ec1e97c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec1e97c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ec1e97c')) {
      api.createRecord('5ec1e97c', component.options)
    } else {
      api.reload('5ec1e97c', component.options)
    }
    module.hot.accept("./upauctionrecord.vue?vue&type=template&id=5ec1e97c&scoped=true&", function () {
      api.rerender('5ec1e97c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/list/upauctionrecord.vue"
export default component.exports